type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
};

/**
 * Plain two-bar pause glyph. The transport pause button used by the Creator
 * Studio stage and the clip preview bar (pairs with `CirclePlayFilledIcon`).
 */
const PauseBarsIcon = (props: Props) => {
  const { width = '32', height = '32', fillColor = 'currentColor' } = props;
  return (
    <svg viewBox="0 0 24 24" width={width} height={height} fill={fillColor}>
      <path d="M14,19H18V5H14M6,19H10V5H6V19Z" />
    </svg>
  );
};

export default PauseBarsIcon;
